import { render, staticRenderFns } from "./CertLogin.component.vue?vue&type=template&id=1306257b&scoped=true"
import script from "./CertLogin.component.vue?vue&type=script&lang=js"
export * from "./CertLogin.component.vue?vue&type=script&lang=js"
import style0 from "./CertLogin.component.vue?vue&type=style&index=0&id=1306257b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1306257b",
  null
  
)

export default component.exports